export default "__VITE_ASSET__Ck36EKOj__"